module.exports = __webpack_public_path__ + "static/media/header_slide_05.8ff084ce.jpg";